<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="grid_header">
          <div></div>
          <div class="text-center ma-4">
            <div class="text_font">ฟอร์มส่งคืน/เปลี่ยนสินค้า</div>
            <div>บริษัท ฟาร์มาแคร์ พลัส จำกัด</div>
          </div>
          <div class="ma-4">
            <div class="grid_flex justify-end">
              <div class="mr-2">เลขที่เอกสาร :</div>
              <div>{{ data_set.doc_no }}</div>
            </div>
            <!-- <div class="grid_flex justify-end">
              <div class="mr-2">TF :</div>
              <div>{{ data_set.tf_no }}</div>
            </div> -->
          </div>
        </div>
        <div class="pa-6">
          <div class="grid_list">
            <div>{{ data_set.supplier_name }}</div>
            <div class="grid_flex">
              <div class="mr-5">ผู้แทน</div>
              <div>{{ data_set.representative }}</div>
            </div>
          </div>
          <div class="grid_list mt-2">
            <div class="grid_flex">
              <div class="mr-4">วันที่แจ้งคืนสินค้า</div>
              <div>{{ diffTH(return_date) }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">วันที่ส่งสินค้า</div>
              <div>{{ diffTH(send_date) }}</div>
            </div>
            <div class="grid_flex">
  <div class="mr-5">ผู้แจ้งคืน</div>
  <div>{{ user_list.name || '-' }}</div>
</div>

            <div class="grid_flex">
              <div class="mr-5">แจ้งโดย</div>
              <div v-if="data_set.notified_by === 0">Line.</div>
              <div v-else-if="data_set.notified_by === 1">โทร</div>
              <div v-else-if="data_set.notified_by === 2">ต่อหน้า</div>
            </div>
          </div>
          <div class="grid_list_second mt-2">
            <div class="grid_flex">
              <div class="mr-2">สาเหตุที่ส่งคืน</div>
              <div v-if="data_set.cause_return === 0">ของมาผิด</div>
              <div v-else-if="data_set.cause_return === 1">ของไม่ได้สั่ง</div>
              <div v-else-if="data_set.cause_return === 2">ชำรุด</div>
              <div v-else-if="data_set.cause_return === 3">{{ data_set.cause_text }}</div>
              <div v-else-if="data_set.cause_return === 4">สินค้าหมดอายุ</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5 red--text">วิธีการแก้ไข</div>
              <div v-if="data_set.issue_select === 0">ทำใบ C/N</div>
              <div v-else-if="data_set.issue_select === 1">คืนเป็นสินค้าเดิม</div>
              <div v-else-if="data_set.issue_select === 2"><span style="color:#7c807d;">(คืนเป็นสินค้าใหม่)</span> {{ data_set.note_issue }}</div>
              <div v-else-if="data_set.issue_select === 3">คืนไปเลยเพราะส่งผิด</div>
            </div>
            <div class="grid_flex">
              <div class="mr-2">หมายเหตุ</div>
              <div>{{ data_set.remark || '-' }}</div>
            </div>
          </div>
        </div>
        <div class="ma-2">
          <v-divider/>
          <v-data-table :headers="headers" :items="datalist" key="index" :items-per-page="perPage" mobile-breakpoint="0" hide-default-footer>
            <template slot="item" slot-scope="dataDetails">
              <tr>
                <td>{{ dataDetails.index + 1 }}</td>
                <td>{{ dataDetails.item.product_name }}</td>
                <td>{{ dataDetails.item.lot_no }}</td>
                <td>{{ format_number(dataDetails.item.qty) }}</td>
                <td>{{ dataDetails.item.unit_name }}</td>
                <td>
                  <div class="ma-4" v-if="dataDetails.item.reason !== null">{{ dataDetails.item.reason }}</div>
                  <div class="ma-4" v-else>-</div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider/>
        </div>
        <div class="pa-6">
          <document_user :user="user_list.name" :create_time="data_set.create_at" :status="data_set.status"/>
        </div>
        <div class="pt-3 pb-5 text-center grid_btn">
          <v-btn x-large @click="return_product" class="grad-main-bg white--text mr-4 ml-4" style="font-size: 18px">ส่งคืนแล้ว</v-btn>
          <v-btn x-large @click="getEdit($route.params.id)" class="grad-warning-bg white--text mr-4 ml-4" style="font-size: 18px">แก้ไขเอกสาร</v-btn>
          <v-btn x-large class="grad-grey-bg white--text mr-4 ml-4" @click="print_document(data_set.doc_no)" style="font-size: 18px">พิมพ์เอกสาร</v-btn>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import document_user from "@/components/admin/document_stock/header_document/document_user";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {diffDateTH, formatNumber} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Document_details",
  components: {
    document_user
  },
  data() {
    return {
      loading_page: false,
      data_set: {},
      overlay: false,
      perPage: -1,
      send_date: '',
      return_date: '',
      headers: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '120px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'รหัสล็อต',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          sortable: false,
          fixed: true,
          width: '120px',
        },
        {
          text: 'หมายเหตุ',
          value: 'reason',
          fixed: true,
          width: '250px',
        },
      ],
      datalist: [],
      user_list: {},
    }
  },
  methods: {
    diffTH: function(value) {
      return diffDateTH(value)
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    get_all() {
  this.loading_page = true;

  // เรียกดึงรายละเอียดเอกสาร
  HTTP.post('/returnproductdocs/detail', {
    return_doc_id: this.$route.params.id
  })
  .then(res => {
    if (!res.data.success) return Promise.reject('detail failed');

    const doc = res.data.doc || {};
    this.data_set    = doc;
    this.send_date   = doc.send_date   || null;
    this.return_date = doc.return_date || null;
    this.datalist    = res.data.doc_lists || [];

    // ต่อด้วยการดึงรายชื่อผู้ใช้
    return HTTP.post('/users/lists', { user_type: 2 });
  })
  .then(resUser => {
    if (resUser.data.success) {
      // ถ้าไม่เจอ ให้ default เป็น {} เพื่อป้องกัน undefined.name
      this.user_list = resUser.data.object.find(u => u.id === this.data_set.return_user_id) || {};
    }
  })
  .catch(err => {
    console.error(err);
  })
  .finally(() => {
    this.loading_page = false;
  });
},

    return_product() {
      Swal.fire({
        title: 'คุณต้องการส่งคืนสินค้าหรือไม่ !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.overlay = true
          HTTP.post('/returnproductdocs/change', {
            return_doc_id: this.$route.params.id,
            status: 1,
            user_login_id: this.$store.state.userDetail.id,
          }).then((res) => {
            if (res.data.success === true) {
              this.$router.push('/stock/document/returnproductreceipt')
            }
          })
        }
      })
    },
    getEdit(id) {
      this.$router.push('/stock/document/governmentreceiptedit/' + id)
    },
    print_document(doc_no) {
      window.open('https://www.pharmacare-plus.com/returnpdf/'+ doc_no, '_blank')
    },
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>
.text_font {
  font-size: 26px;
}
.grid_flex {
  display: flex;
}
.grid_header {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}
.grid_list {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_list_second {
  display: grid;
  grid-template-columns: 25% 25% 50%;
}
@media only screen and (max-width: 1024px) {
  .grid_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_list_second {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 700px) {
  .grid_header {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_btn {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>